var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTurtle1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Turtle_1_",
    d: "M10.7253 3.7381C10.7253 3.7381 9.67033 0.5 6.15385 0.5C2.63736 0.5 1.75824 4.5 1.75824 4.5C1.75824 4.5 0 4.88095 0 5.83333C0 5.83333 0.527473 7.16667 1.93407 7.35714C1.93407 7.35714 1.40659 7.92857 1.75824 8.5H5.0989C5.0989 8.5 5.0989 7.92857 4.74725 7.7381C4.74725 7.7381 4.57143 7.35714 4.92308 7.35714C5.27473 7.35714 8.79121 7.35714 8.79121 7.35714C8.79121 7.35714 8.26374 7.92857 8.61539 8.5H12.3077C12.3077 8.5 12.3077 7.7381 11.7802 7.7381C11.7802 7.7381 10.9011 6.78571 11.956 6.21429C11.956 6.21429 13.3626 5.83333 14.4176 4.5C14.4176 4.5 16 4.30952 16 2.97619C16 1.64286 14.5934 1.64286 14.0659 1.64286C13.5385 1.64286 11.7802 2.40476 11.7802 3.7381H10.7253Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurtle1);
export default __webpack_public_path__ + "static/media/Turtle_1_.6da6d0b4326a528c66f8e997d6951c3e.svg";
export { ForwardRef as ReactComponent };